import type { GetSpaceLanguagesServiceConfig, GetUserAddonsServiceConfig, GetVoicesServiceConfig } from '@/services/httpServices/GeneralServices/types';

import { createQueryKey } from './queryKeyUtils';

export function userAddonsKeys(config?: GetUserAddonsServiceConfig) {
  return createQueryKey(['userAddons'], config);
}

export function spaceLanguagesKeys(config?: GetSpaceLanguagesServiceConfig) {
  return createQueryKey(['spaceLanguages'], config);
}

export function voicesKeys(config?: GetVoicesServiceConfig) {
  return createQueryKey(['voices'], config);
}
